import RoomMeasurementManage from "@/pages/roomMeasurementTools/roomMeasurementManage/components/List/list.tsx";
import {LineChart} from "@/pages/roomMeasurementTools/roomMeasurementManage/components/Charts/LineChart.tsx";

export default function RoomMeasurementManagePage() {
  return <>
    <LineChart/>
    <RoomMeasurementManage/>
  </>
}